import React, { Component } from "react";
import Datas from "../../data/facilities/library.json"

import { Container, Row, Col } from "react-bootstrap";


import { Styles } from "./styles/events.js";

import { BreadcrumbBox } from "../../components/common/Breadcrumb.js";

import PopularLibrary from "../../components/facilities/PopularLibrary.js";
import HeaderTwo from "../../components/HeaderTwo.js";
import FooterTwo from "../../components/FooterTwo.js";

class Library extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper event-details-page">
          {/* Header 2 */}
          <HeaderTwo />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Library" />

          {/* Library Details Area */}
          <section className="event-details-area">
            <Container>
              <Row>
                <Col lg="9" md="8" sm="12">
                  <div className="event-details-content">
                    <div className="heading">
                      <h4>Extensive Library for Knowledge and Growth</h4>
                    </div>
                    <div className="event-icon">
                      <ul className="list-unstyled list-inline">
                        <li className="list-inline-item">
                          <i className="las la-book"></i> Extensive Book
                          Collection
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-desktop"></i> Digital Library
                          Access
                        </li>
                        <li className="list-inline-item">
                          <i className="las la-user-graduate"></i> Research &
                          Study Areas
                        </li>
                      </ul>
                    </div>
                    <div className="event-details-banner">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          `/assets/images/library.jpg`
                        }
                        alt="Library"
                        className="img-fluid"
                      />
                    </div>
                    <div className="event-details-overview">
                      <h5>Library Overview</h5>
                      <p>
                      N. S. S. English Medium High School boasts a well-stocked library designed to support students' academic and personal development. With a collection of over 1,500 books, the library provides access to a wide range of resources, including textbooks, reference materials, fiction, non-fiction, and periodicals. It serves as a hub for research, learning, and intellectual exploration.A dedicated librarian ensures proper book management and assists students in finding relevant resources.
                      </p><br/><p>
                      The library offers a quiet and comfortable reading environment, encouraging students to cultivate a love for reading and independent learning. Equipped with seating arrangements and a systematic cataloging system, it allows easy access to books and study materials. In addition to printed books, the library provides digital learning resources, enhancing students&npos; knowledge beyond the curriculum.The library is open during school hours, allowing students and teachers to utilize its facilities for academic growth, project work, and research activities.
                      </p>
                      <ul className="list-unstyled">
  <li>
    <i className="fa fa-check"></i> Our school library boasts a vast collection of books, including academic textbooks, reference materials, fiction, and non-fiction, ensuring students have access to a wealth of knowledge across multiple subjects and disciplines.
  </li>
 
  <li>
    <i className="fa fa-check"></i> We have dedicated reading and study zones designed to foster a peaceful and focused learning environment, enabling students to concentrate on their studies, complete assignments, and prepare for examinations without distractions.
  </li>
  <li>
    <i className="fa fa-check"></i> Equipped with modern computer stations, our library offers students the opportunity to utilize online educational tools, research databases, and interactive learning platforms to further their academic pursuits and personal growth.
  </li>
</ul>


                    </div>
                
                    <div className="event-details-speaker">
                      <h5>Library Facilities</h5>
                      <Row>
                        {Datas.map((data, i) => (
                          <Col lg="3" md="6" sm="6" key={i}>
                            <div className="event-speaker-item">
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  `/assets/images/${data.personImage}`
                                }
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                    <div className="event-details-overview">
                      {/* <h5>Library Committee</h5> */}
                      {/* <p>
                        Our library is a knowledge hub with an extensive
                        collection of books, research materials, and digital
                        resources. It provides an ideal environment for students
                        to study, explore ideas, and enhance learning across
                        diverse subjects like literature, history, science, and
                        technology.Equipped with modern facilities, including
                        high-speed internet, digital archives, and multimedia
                        resources, students can access a wealth of information.
                      </p> */}
 <div>
      {/* <ul className="list-unstyled">
        <li>
          <i className="fa">1</i>
          <span className="font-weight-bold"> Dr. Arun Kumar </span>
          <br />
          <span>Chairman</span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">2</i>
          <span> Dr. Priya Sharma </span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">3</i>
          <span> Mr. Rajesh Verma </span>
        </li>
      </ul>

      <ul className="list-unstyled">
        <li>
          <i className="fa">4</i>
          <span> Ms. Anjali Nair </span>
        </li>
      </ul> */}
    </div>


                    </div>
                  </div>

            
                </Col>

                

                <Col lg="3" md="4" sm="12">
                  <div className="event-details-sidebar">
                    <Row>
                      <Col md="12">
                        <div className="event-sidebar-info">
                        <ul className="list-unstyled event-info-list">
  <li>Collection: <span>1,500+ Books</span></li>
  <li>Digital Access: <span>Online Resources</span></li>
  <li>Study Areas: <span>Quiet Space</span></li>

  <li>Membership: <span>Students & Teachers</span></li>

</ul>

                        </div>
                      </Col>
                      <Col md="12">
                        <PopularLibrary />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>

          {/* Footer 2 */}
          <FooterTwo />
        </div>
      </Styles>
    );
  }
}

export default Library;
